// LOS COLORES DE LA PÁGINA PÚBLICA DEL BOOKING LINK, a partir de UN color.
//
// Gabriel De Silva, 2026-10-30: quería la cabecera con el color de su marca; el
// azul estaba fijo (E-404). El agente elige un solo color y de él salen los
// demás: el degradado de la cabecera y los botones, el texto que va encima
// (blanco o casi negro, según lo claro que sea), los títulos sobre fondo blanco
// y los fondos suaves de las horas. Sin color, sale exactamente lo de siempre.
import { tagTextColor } from './utils.js';

const HEX = /^#[0-9a-f]{6}$/i;

const DE_SIEMPRE = {
  principal: '#0a558c', segundo: '#0891b2', sobre: '#ffffff',
  titulos: '#0a558c', enlaces: '#0891b2', suave: '#f0f9ff', suave2: '#ecfeff', borde: '#bae6fd',
  fondo: 'linear-gradient(160deg,#eef6ff,#f8fbff)',
};

function aRgb(hex) {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
function aHex([r, g, b]) {
  return `#${[r, g, b].map((x) => Math.round(Math.max(0, Math.min(255, x))).toString(16).padStart(2, '0')).join('')}`;
}
/** Mezcla `hex` con `con` en la proporción `p` (0 = hex tal cual, 1 = `con`). */
export function mezclar(hex, con, p) {
  const a = aRgb(hex), b = aRgb(con);
  return aHex(a.map((x, i) => x + (b[i] - x) * p));
}
const claridad = (hex) => { const [r, g, b] = aRgb(hex); return (0.299 * r + 0.587 * g + 0.114 * b) / 255; };

export function coloresDelEnlace(color) {
  const c = typeof color === 'string' ? color.trim().toLowerCase() : '';
  if (!HEX.test(c)) return DE_SIEMPRE;
  // Un color muy claro (amarillo, beige…) no se lee como texto sobre blanco:
  // los títulos y enlaces usan una versión oscurecida.
  const legible = claridad(c) > 0.6 ? mezclar(c, '#000000', 0.5) : c;
  return {
    principal: c,
    segundo: mezclar(c, '#ffffff', 0.25),
    sobre: tagTextColor(c),
    titulos: legible,
    enlaces: legible,
    suave: mezclar(c, '#ffffff', 0.93),
    suave2: mezclar(c, '#ffffff', 0.9),
    borde: mezclar(c, '#ffffff', 0.7),
    fondo: `linear-gradient(160deg,${mezclar(c, '#ffffff', 0.92)},#f8fbff)`,
  };
}

/** Colores para elegir con un clic en los ajustes del enlace (el primero, el de siempre). */
export const COLORES_SUGERIDOS = ['#0a558c', '#0f766e', '#15803d', '#7c3aed', '#be185d', '#b91c1c', '#c2410c', '#1f2937'];
